import React from 'react';
import { Dialog, DialogContent, Typography } from '@mui/material';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import ModalHeader from '../../../shared/components/ModalHeader';
import type { AccountBaselineView } from '../../../types/backend';

import OnboardingGates from './OnboardingGates';

export interface AccountFlowModalProps {
  open: boolean;
  onClose: () => void;
  awsAccountId: string;
  accountName?: string;
  /** Everything the ladder is derived from. */
  account: AccountBaselineView;
  /** From the account record: a disabled account is skipped by everything. */
  enabled?: boolean;
}

/**
 * Where this account is in onboarding: one question per row, in the order they
 * must hold, and one indicator each.
 *
 * Nothing else. No phase strip, no durations, no descriptions: an operator
 * watching an onboarding wants the rung it is on, and the reconciler's own
 * structure is a different question asked from a different screen.
 *
 * Read-only. The only trigger that exists runs the whole reconciler across
 * every account, and `ops:Start` replaces stored desired state before running,
 * so both belong somewhere their scope is obvious without a disclaimer.
 */
const AccountFlowModal: React.FC<AccountFlowModalProps> = ({
  open, onClose, awsAccountId, accountName, account, enabled,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <ModalHeader
        icon={PlayArrowIcon}
        title="Onboarding"
        onClose={onClose}
        subtitle={
          <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
            {accountName ? `${accountName} · ` : ''}{awsAccountId}
          </Typography>
        }
      />

      <DialogContent sx={{ px: { xs: 2, sm: 3 }, py: 2 }}>
        <OnboardingGates account={account} enabled={enabled} />
      </DialogContent>

    </Dialog>
  );
};

export default AccountFlowModal;
